{
  "version": 1,
  "asset_id": "e44fe1ec-b8e7-4148-8f04-e4379dc63709",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/e44fe1ec-b8e7-4148-8f04-e4379dc63709/main-480.avif",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/e44fe1ec-b8e7-4148-8f04-e4379dc63709/main-480.avif",
  "original_filename": "main-480.avif",
  "size": 5585,
  "content_type": "image/avif",
  "created_at": "2026-07-17T19:12:00Z"
}
